// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"53ef3f46","732":"8bbd0c8c","977":"260d406e"}[chunkId] + ".chunk.js");